var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgS3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 61,
    viewBox: "0 0 61 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clips3)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.2115 35.8497L20.0051 37.2494L22.9746 38.54L26.418 37.2494L23.2115 35.8497ZM18.3909 37.5993L18.2834 43.8981L22.9746 45.9976V39.4582L18.3909 37.5993ZM28.0322 37.5993L23.7927 39.2398V45.407L28.0322 43.6574V37.5993ZM33.0897 18.0032L29.8612 19.4029L32.8528 20.6935L36.2961 19.4029L33.0897 18.0032ZM28.6134 19.8627V26.1615L32.6159 27.3428L32.7454 21.6124L28.6134 19.8627ZM37.5661 20.2126L33.7784 21.8531V28.0427L37.5661 26.2931V20.2126H37.5661ZM17.9281 26.8683L14.7217 28.2681L17.6912 29.5586L21.1345 28.2681L17.9281 26.8683ZM13.1074 28.618L13 34.9168L17.6912 37.0164V30.4768L13.1074 28.618ZM22.7488 28.618L18.5093 30.2585V36.4256L22.7488 34.676V28.618ZM28.2581 26.636L25.0516 28.0357L28.0212 29.3263L31.4645 28.0357L28.2581 26.636ZM23.4374 28.3857L23.3299 34.6844L28.0211 36.784V30.2452L23.4374 28.3857ZM33.0787 28.3857L28.8393 30.0261V36.1933L33.0787 34.4437V28.3857ZM43.1794 18.0032L39.973 19.4029L42.9425 20.6934L46.3858 19.4029L43.1794 18.0032ZM38.3587 19.7528L38.2513 26.0516L42.9425 28.1512V21.6124L38.3587 19.7528ZM48 19.7528L43.7606 21.3933V27.5605L48 25.8108V19.7528Z",
    fill: "#F7A80D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clips3"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 28,
    fill: "white",
    transform: "translate(13 18)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgS3);
export default __webpack_public_path__ + "static/media/s3.f107a68214395d4da9c8953a5fd620bd.svg";
export { ForwardRef as ReactComponent };